import { render, staticRenderFns } from "./NewTestCase.vue?vue&type=template&id=4f5fb10a&"
import script from "./NewTestCase.vue?vue&type=script&lang=ts&"
export * from "./NewTestCase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports